module.exports = __webpack_public_path__ + "img/ill1.1101d4da.svg";